import React from 'react';
import { Form, Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import {
  RenderTextField as TextField,
  RenderDropDownField as DropDown, RenderSwitchField as Switch,
  UploadField
} from '../../formInputs';

import Message from '../../components/Message';

import Dashboard from '../../components/Dashboard';
import { broadcastMessage } from '../../redux/modules/common/action';

const styles = theme => ({
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  success: {
    // backgroundColor: green500,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: '#ffffff',
    backgroundColor: theme.palette.error.dark,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 400,
  },
});

class Broadcast extends React.Component {
  state = {
    message: null
  }

  sendMail = async (props) => {
    const { dispatch } = this.props;
    const res = await dispatch(broadcastMessage(props));
    if (res.data) {
      let message;
      if (res.data === 1) {
        message = 'Email Sent';
      } else {
        message = 'Post Sent';
      }

      this.setState({ message });
    }
  }

  close = () => {
    this.setState({ message: null });
  }

  render () {
    const { classes, handleSubmit } = this.props;
    const { message } = this.state;

    const userTypes = [
      {
        label: 'Email',
        value: 'email'
      },
      {
        label: 'Post',
        value: 'post'
      }
    ];

    return (
      <Dashboard>

        { message && 
          <Message message={message} isOpen={message ? true : false } close={this.close}/>
        }

        <Form className={classes.form} onSubmit={handleSubmit(this.sendMail)}>
          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Broadcast As</FormLabel>
            <Field
              className={classes.textField}
              name="type"
              component={DropDown}
              options={userTypes}
            />
          </FormControl>

          <FormControl margin="normal" fullWidth>
            <Field
              className={classes.textField}
              name="subject"
              component={TextField}
              label="Subject"
            />
          </FormControl>


          <FormControl margin="normal" fullWidth>
            <FormLabel component="legend">Upload Attachments</FormLabel>
            <Field name="postImages" component={UploadField} label="Upload Profile Pic" />
          </FormControl>


          <FormControl margin="normal" required fullWidth>
            <Field
              name="message"
              component={TextField}
              label="Content"
              multiline
              rowsMax="20"
              required
            />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Send
          </Button>

        </Form>
      </Dashboard>
    )
  }
}

const form = reduxForm({
  form: 'broadcast'
});

export default form(withStyles(styles)(Broadcast));